module.exports = __webpack_public_path__ + "img/figure5.9dfc89e3.png";